<template>
  <div class="vagal-maneuver-check">
    <el-card>
      <div>
        <help-tooltip v-if="warnings.length" type="warning">
          <span v-for="warning in warnings" :key="warning.message">
            {{ warning.message }}
            <br>
          </span>
        </help-tooltip>
        <span>
          {{ label ? label : `Was ${vital.name.en.toLowerCase()} checked ?` }}
        </span>
      </div>
    </el-card>
  </div>
</template>

<script>
import get from 'lodash/get';
import uniqBy from 'lodash/uniqBy';

import HelpTooltip from '~lib/common/components/HelpTooltip';

export default {
  name: 'vital-assessed-check',
  components: {
    HelpTooltip,
  },
  props: [
    'states',
    'vitalKey',
    'label',
    'readonly',
    'emitter',
    'ikey',
    'getData',
    'putData',
    'control',
  ],
  data() {
    return {
      state: {
        vitals: this.states.filter(s => s.category === 'vital' || s.category === 'labResult'),
        check: {},
      },
    };
  },
  computed: {
    warnings() {
      if (!this.emitter.$store) {
        return [];
      }
      const warnings = get(
        this.emitter.$store.getters['validation/visibleWarningsByFieldAndId'],
        `caseLogicDescription.${this.control.parent.id}`,
        [],
      ).filter(warning => warning.metadata && warning.metadata.checkKey === this.ikey);

      return uniqBy(warnings, 'message');
    },
    vital() {
      return this.state.vitals.find(v => v.key === this.vitalKey);
    },
  },
  beforeMount() {
    this.update();
  },
  methods: {
    update() {
      this.putData(this.ikey, {
        type: this.vital.category === 'labResult' ? 'LAB_RESULT_VIEWED' : 'VITAL_ASSESS',
        id: this.vitalKey,
        operator: 'EQUAL',
        value: true,
      });
      this.emitter.trigger('process', this.control);
    },
  },
};
</script>

<style scoped>
.vagal-maneuver-check, .el-card {
  width: 100%;
  color: black;
}
</style>
